import styles from './Loading.module.scss';

const Loading = () => <div className={styles.loading} />;

export default Loading;
